import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Crown } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const TAB = { regions: "Regions", strongest: "Strongest", grimfang: "Grimfang", vexa: "Vexa", nocturne: "Nocturne" };

export default function AdminChampions() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/champions").then(({ data }) => setRows(data));
  useEffect(() => { load(); }, []);
  const award = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/champions/award");
      toast[data.already_awarded ? "info" : "success"](data.already_awarded ? `Week ${data.week} was already awarded` : `Awarded ${data.awards} champions for ${data.week}`);
      load();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="glass rounded-2xl p-6" data-testid="admin-champions">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <h3 className="font-display text-xl text-amber-100">Weekly champions</h3>
          <p className="text-xs text-slate-400">Runs automatically every Monday 00:05 UTC for the week that just ended: 5,000 / 3,000 / 1,500 credits to the top 3 on each weekly board.</p>
        </div>
        <button data-testid="admin-award-champions-btn" disabled={busy} onClick={award} className="ember-btn px-5 py-2 rounded-full text-xs">AWARD LAST WEEK NOW</button>
      </div>
      {!rows.length && <p className="text-sm text-slate-500">No champions awarded yet.</p>}
      <div className="space-y-1.5">
        {rows.map((r) => (
          <div key={`${r.week}-${r.tab}-${r.rank}`} className="flex items-center gap-3 text-sm px-3 py-2 rounded-lg bg-slate-900/60">
            <span className="font-mono-game text-xs text-slate-500 w-20">{r.week}</span>
            <Crown className={`w-4 h-4 ${["text-amber-300", "text-slate-200", "text-orange-300"][r.rank - 1]}`} />
            <span className="w-24 text-slate-400">{TAB[r.tab]} #{r.rank}</span>
            <span className="flex-1 truncate">{r.wolf_name}</span>
            <span className="font-mono-game text-amber-200">+{r.credits}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
